export const MUTATION_DECREMENT_COUNT = /* GraphQL */ `
	mutation ($key: String!) {
		decrementCount(key: $key) {
			countValue {
				total
				cid
			}
		}
	}
`;
